import {
  ChangeDetectionStrategy,
  Component,
  inject,
  type OnInit,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PaymentService } from "../../shared/services/payment.service";

@Component({
    selector: "app-receipt",
    imports: [],
    templateUrl: "./receipt.component.html",
    styleUrls: ["./receipt.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiptComponent implements OnInit {
  route = inject(ActivatedRoute);
  paymentService = inject(PaymentService);

  payRef: string;
  ngOnInit(): void {
    this.route.queryParams.subscribe((param) => {
      if (param.payRef) {
        this.payRef = param.payRef;
      }
    });
  }

  downloadReceipt() {
    this.paymentService.collectionNotification(this.payRef).subscribe((res) => {
      if (res.receiptNumber) {
        window.location.href = res.receiptNumber;
      }
    });
  }
}
